"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.flattenOptions = exports.constructOptions = exports.isValueOrItemEqualToOption = exports.isValueOrItemInOptionsList = exports.filterOptions = exports.isAsyncConfiguration = exports.optionContainsQuery = exports.isSelectOptionOrGroup = void 0;
var react_1 = __importDefault(require("react"));
var isSelectOptionOrGroup = function (option) {
    return typeof option === "object" && ("value" in option || "heading" in option);
};
exports.isSelectOptionOrGroup = isSelectOptionOrGroup;
var optionContainsQuery = function (option, query) {
    // TODO this doesn't handle accents, but code could be written to do that if needed.
    var subject = ("" + option.label + option.value).replace(/ /g, "").toLowerCase();
    return subject.indexOf(query.replace(/ /g, "").toLowerCase()) > -1;
};
exports.optionContainsQuery = optionContainsQuery;
var isAsyncConfiguration = function (configuration) { return typeof configuration.options === "function"; };
exports.isAsyncConfiguration = isAsyncConfiguration;
var filterOptions = function (options, query, optionPredicate) {
    if (optionPredicate === void 0) { optionPredicate = exports.optionContainsQuery; }
    var results = [];
    // Simple text search based on label, then value.
    options.forEach(function (option) {
        // Searching a regular option
        if (exports.isSelectOptionOrGroup(option) && "value" in option) {
            if (optionPredicate(option, query)) {
                results.push(option);
            }
        }
        else {
            // Searching an option group.
            var filteredGroupOptions_1 = [];
            option.options.forEach(function (groupOption) {
                if (exports.optionContainsQuery(groupOption, query)) {
                    filteredGroupOptions_1.push(groupOption);
                }
            });
            if (filteredGroupOptions_1.length) {
                results.push(__assign(__assign({}, option), { options: filteredGroupOptions_1 }));
            }
        }
    });
    return results;
};
exports.filterOptions = filterOptions;
var isValueOrItemInOptionsList = function (options, itemOrValue) {
    return options.some(function (option) {
        return exports.isValueOrItemEqualToOption(option, itemOrValue);
    });
};
exports.isValueOrItemInOptionsList = isValueOrItemInOptionsList;
var isValueOrItemEqualToOption = function (optionOrValue, itemOrValue) {
    var optionValue;
    var itemValue;
    var optionType = typeof optionOrValue;
    if (optionOrValue === undefined ||
        optionOrValue === null ||
        optionType === "string" ||
        optionType === "number" ||
        optionType === "boolean") {
        optionValue = optionOrValue;
    }
    else {
        optionValue = optionOrValue;
        if (typeof optionOrValue === "object") {
            if ("value" in optionOrValue) {
                optionValue = optionOrValue.value;
            }
        }
    }
    var itemType = typeof itemOrValue;
    if (itemOrValue === undefined ||
        itemOrValue === null ||
        itemType === "string" ||
        itemType === "number" ||
        itemType === "boolean") {
        itemValue = itemOrValue;
    }
    else {
        itemValue = itemOrValue;
        if (typeof itemOrValue === "object") {
            if ("value" in itemOrValue) {
                itemValue = itemOrValue.value;
            }
        }
    }
    var optionValueType = typeof optionValue;
    var itemValueType = typeof itemValue;
    if ((optionValue === undefined ||
        optionValue === null ||
        optionValueType === "string" ||
        optionValueType === "number" ||
        optionValueType === "boolean") &&
        (itemValue === undefined ||
            itemValue === null ||
            itemValueType === "string" ||
            itemValueType === "number" ||
            itemValueType === "boolean")) {
        return optionValue === itemValue;
    }
    // Object comparisons are a little fragile. It's possible for a newly created value
    // for example to be returned with a slightly different structure thant ones returned
    // in the general list or search. In many cases the item value contains an id property.
    // If both option and item have an id - we should use that first.
    if (optionValue &&
        itemValue &&
        typeof optionValue === "object" &&
        typeof itemValue === "object" &&
        "id" in optionValue &&
        "id" in itemValue) {
        // @ts-ignore
        return optionValue.id === itemValue.id;
    }
    // Slow but sure.
    if (JSON.stringify(optionValue) !== JSON.stringify(itemValue)) {
        // leaving the if statement here for future debug purposes. If we get this far
        // we're generally finding that new options are showing twice in the select
        // because our equivilence test is seeing them as 'different' objects.
        return false;
    }
    return true;
};
exports.isValueOrItemEqualToOption = isValueOrItemEqualToOption;
var constructOptions = function (options, values, customMakePredicate, autoLabelProperty) {
    if (autoLabelProperty === void 0) { autoLabelProperty = "name"; }
    // Clone options so we aren't fiddling with any state.
    var clonedOptions = __spreadArray([], options);
    // Add to options any values that aren't represented there. This ensures
    // that if the drop down no longer has the values in the list they will continue
    // to be selected.
    for (var _i = 0, _a = values; _i < _a.length; _i++) {
        var value = _a[_i];
        if (value) {
            if (!exports.isValueOrItemInOptionsList(clonedOptions, value)) {
                // @ts-ignore
                clonedOptions.push(value);
            }
        }
    }
    var mapped = clonedOptions.map(function (option) {
        if (option || typeof option === "string") {
            if (exports.isSelectOptionOrGroup(option)) {
                return option;
            }
            if (customMakePredicate) {
                return customMakePredicate(option);
            }
            if (typeof option === "object" &&
                autoLabelProperty &&
                // @ts-ignore - TS not happy that V might be an object
                option.hasOwnProperty(autoLabelProperty)) {
                return {
                    item: option,
                    value: option,
                    // @ts-ignore - we want 'name' as a sensible auto default for the label
                    // but TS knows V may not include it - despite the hasOwnProperty wrap
                    label: option[autoLabelProperty],
                };
            }
            if (typeof option == "string") {
                return {
                    value: option,
                };
            }
        }
        return {
            value: option,
            label: (react_1.default.createElement("span", { title: "Check autoLabelProperty - not set or doesn't exist on object" }, "Error - no label")),
        };
    });
    return mapped;
};
exports.constructOptions = constructOptions;
var flattenOptions = function (options) {
    var flatOptions = [];
    options.forEach(function (option) {
        if (option) {
            if ("options" in option) {
                flatOptions.push.apply(flatOptions, option.options);
            }
            else {
                flatOptions.push(option);
            }
        }
    });
    return flatOptions;
};
exports.flattenOptions = flattenOptions;
//# sourceMappingURL=UseSelectUtils.js.map